"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
require("@rmlibrary/canvas-player-controls");
var canvas_player_1 = require("@rmlibrary/canvas-player");
var utilities_1 = require("./utilities");
var custom_elements_1 = require("@rmlibrary/custom-elements");
var animation_1 = require("./animation");
var language = (0, utilities_1.getLanguage)();
var timelineSceneData = new Map();
var devicePixelRatio = (0, utilities_1.getDevicePixelRatio)();
var container = document.querySelector(".cp-container");
var playerControls = document.getElementsByTagName("rm-canvas-player-controls")[0];
var DEBUG = false;
var testingUrlEn = "https://publish1canadacentral.qa.scotiaweb.adobecqms.net/content/swm/swm/ca/en/connect-with-us.html";
var testingUrlFr = "https://publish1canadacentral.qa.scotiaweb.adobecqms.net/content/swm/swm/ca/fr/communiquez-avec-nous.html";
var productionUrlEn = "https://www.scotiawealthmanagement.com/ca/en/connect-with-us.html";
var productionUrlFr = "https://www.scotiawealthmanagement.com/ca/fr/communiquez-avec-nous.html";
var RMDynamicVideo = /** @class */ (function (_super) {
    __extends(RMDynamicVideo, _super);
    function RMDynamicVideo() {
        var _this = this;
        _this.embedMode = false;
        _this.ready = false;
        _this.gettingSceneInfo = false;
        // @ts-ignore
        return _this = _super.call(this) || this;
    }
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    RMDynamicVideo.prototype.connectedCallback = function () {
        this.container = document.getElementsByClassName("cp-container")[0];
        this.controls = document.getElementsByTagName("rm-canvas-player-controls")[0];
        this.largePlayButton = document.getElementsByClassName("cp-large-play")[0];
        this.largeReplayButton = document.getElementsByClassName("cp-large-replay")[0];
        this.pauseButton = document.getElementsByClassName("cp-pause")[0];
        this.playButton = document.getElementsByClassName("cp-play")[0];
        this.replayButton = document.getElementsByClassName("cp-replay")[0];
        this.videoElem = document.getElementsByClassName("cp-video")[0];
        this.videoElemAlt = document.getElementsByClassName("cp-video-preload")[0];
        this.preloader = playerControls.querySelector(".cp-preloader");
    };
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    RMDynamicVideo.prototype.disconnectedCallback = function () {
        var _a, _b;
        (_a = this.controls) === null || _a === void 0 ? void 0 : _a.removeEventListeners();
        (_b = this.player) === null || _b === void 0 ? void 0 : _b.destroy();
    };
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    RMDynamicVideo.prototype.initVideo = function (data, embedMode) {
        var _this = this;
        var _a, _b;
        console.log("Initializing");
        this.embedMode = embedMode;
        this.stageVars = data;
        this.initialLoad = true;
        //set src location of video
        var activeElem = document.querySelector(".cp-video");
        activeElem.src = "../common/videos/" + language + "/" + "scotia-intro.mp4";
        var preloadElem = document.querySelector(".cp-video-preload");
        preloadElem.src = "../common/videos/" + language + "/" + "scotia-intro.mp4";
        //prevent background click-to-play on initial load
        this.container.style.pointerEvents = "none";
        (0, animation_1.loadAnimations)(data.timeline).then(function (animations) { return _this.handleLoadedAnimations(animations); });
        (_a = this.videoElem) === null || _a === void 0 ? void 0 : _a.pause();
        (_b = this.videoElemAlt) === null || _b === void 0 ? void 0 : _b.pause();
    };
    RMDynamicVideo.prototype.updateAnimationTimeline = function (animations, startScene) {
        var _a, _b;
        (_a = this.player) === null || _a === void 0 ? void 0 : _a.reflow(animations, {
            scene: startScene
        });
        //
        (_b = this.player) === null || _b === void 0 ? void 0 : _b.play();
        this.largePlayButton.classList.add("hide");
        this.pauseButton.classList.remove("hide");
        this.playButton.classList.add("hide");
        this.replayButton.classList.add("hide");
        //this.updateCurrentScene(startScene);
    };
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    RMDynamicVideo.prototype.playVideo = function () {
        var _this = this;
        if (this.player && this.ready) {
            setTimeout(function () {
                var _a, _b;
                (_a = _this.player) === null || _a === void 0 ? void 0 : _a.play();
                (_b = _this.largePlayButton) === null || _b === void 0 ? void 0 : _b.classList.add("hide");
            }, 100);
        }
    };
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    RMDynamicVideo.prototype.resetVideo = function () {
        var _a, _b, _c, _d, _e, _f;
        //this.player?.pause();
        (_a = this.player) === null || _a === void 0 ? void 0 : _a.goToFrame(0);
        (_b = this.pauseButton) === null || _b === void 0 ? void 0 : _b.classList.add("hide");
        (_c = this.playButton) === null || _c === void 0 ? void 0 : _c.classList.add("hide");
        (_d = this.largePlayButton) === null || _d === void 0 ? void 0 : _d.classList.add("hide");
        (_e = this.replayButton) === null || _e === void 0 ? void 0 : _e.classList.add("hide");
        var clipsToReset = ((_f = this.stageVars) === null || _f === void 0 ? void 0 : _f.clipsToReset) || [];
        while (clipsToReset.length) {
            var instance = clipsToReset.pop();
            instance.isSingleFrame = false;
        }
    };
    RMDynamicVideo.prototype.updateVideoData = function (data) {
        var _a;
        (_a = this.player) === null || _a === void 0 ? void 0 : _a.updateStageVars(data);
        if (this.controls) {
            this.controls.formatTranscript = this.formatTranscript();
        }
        this.updateTranscript();
    };
    RMDynamicVideo.prototype.formatTranscript = function () {
        return function (text) {
            //console.log(text, "---tttext");
            var formattedText = "";
            if (text) {
                formattedText = text;
            }
            return formattedText;
        };
    };
    RMDynamicVideo.prototype.loadBgMusic = function (src) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var queue = new createjs.LoadQueue(true);
            queue.installPlugin(createjs.Sound);
            queue.on("complete", function () {
                var _a;
                try {
                    var inst = createjs.Sound.play("bgMusic", { loop: -1 });
                    inst.paused = true;
                    //if player is already playing, start the sound
                    if (!((_a = _this.player) === null || _a === void 0 ? void 0 : _a.paused)) {
                        inst.paused = false;
                    }
                    resolve(inst);
                }
                catch (e) {
                    reject(e);
                }
            });
            queue.on("error", function (e) {
                reject(new Error(e.message));
            });
            queue.loadFile({ id: "bgMusic", src: src });
        });
    };
    RMDynamicVideo.prototype.handleLoadedAnimations = function (animations) {
        var _this = this;
        var _a, _b;
        var overlay = null;
        var currentFrame;
        var stopFrames = [];
        var chapterData = [];
        var nextLockedFrame;
        var stoppedAtFrame = false;
        var bgSound;
        var hidden = "";
        var updatedTimeline;
        var isVideoLoading = true;
        var isScrubbing = false;
        var isPreloading = false;
        var videosSwapped = false;
        var pausedForLoading = false;
        var replaying = false;
        var onSelectionScreen = false;
        var preloadVideo = function (sceneName) {
            isPreloading = true;
            resetVideoSources();
            var activeElem = document.querySelector(".cp-video");
            activeElem.src = "../common/videos/" + language + "/" + sceneName + ".mp4";
            activeElem.pause();
            var altElem = document.querySelector(".cp-video-preload");
            altElem.pause();
        };
        var stringRemapper = function (varName) {
            var varFound = false;
            var objectRemaps = language == "en" ? objectRemapsEn : objectRemapsFr;
            for (var i = 0; i < Object.keys(objectRemaps).length; i++) {
                var key = Object.keys(objectRemaps)[i];
                var value = Object.values(objectRemaps)[i];
                if (key.includes(varName)) {
                    varFound = true;
                    return value;
                }
                if (!varFound) {
                    "no remap found for *".concat(varName, "*");
                }
            }
        };
        var chapterObj = {
            chapterFrame: 0,
            activated: false,
            ariaLabel: ""
        };
        var videoObjs = {
            videoIntro: "../common/videos/" + language + "/scotia-intro.mp4",
            videoPreQ2: "../common/videos/" + language + "/scotia-pre-q2.mp4",
            videoGoalLegacy: "../common/videos/" + language + "/scotia-goal-legacy.mp4",
            videoGoalHome: "../common/videos/" + language + "/scotia-goal-home.mp4",
            videoGoalTravel: "../common/videos/" + language + "/scotia-goal-travel.mp4",
            videoGoalChildren: "../common/videos/" + language + "/scotia-goal-children.mp4",
            videoGoalExpandbusiness: "../common/videos/" + language + "/scotia-goal-expand-business.mp4",
            videoGoalLifestyle: "../common/videos/" + language + "/scotia-goal-lifestyle.mp4",
            videoGoalNest: "../common/videos/" + language + "/scotia-goal-nest.mp4",
            videoGoalParents: "../common/videos/" + language + "/scotia-goal-parents.mp4",
            videoGoalStartbusiness: "../common/videos/" + language + "/scotia-goal-start-business.mp4",
            videoGoalSuccession: "../common/videos/" + language + "/scotia-goal-succession.mp4",
            videoQ2C1: "../common/videos/" + language + "/scotia-q2-choice-1.mp4",
            videoQ2C2: "../common/videos/" + language + "/scotia-q2-choice-2.mp4",
            videoQ2C3: "../common/videos/" + language + "/scotia-q2-choice-3.mp4",
            videoQ2C4: "../common/videos/" + language + "/scotia-q2-choice-4.mp4",
            videoQ3C1: "../common/videos/" + language + "/scotia-q3-choice-1.mp4",
            videoQ3C2: "../common/videos/" + language + "/scotia-q3-choice-2.mp4",
            videoQ3C3: "../common/videos/" + language + "/scotia-q3-choice-3.mp4",
            videoQ3C4: "../common/videos/" + language + "/scotia-q3-choice-4.mp4",
            videoPreOutro: "../common/videos/" + language + "/scotia-pre-outro.mp4",
            videoOutro: "../common/videos/" + language + "/scotia-outro.mp4"
        };
        //string remapping en
        var objectRemapsEn = {
            "scotia-intro-image": "",
            "scotia-intro": "",
            "scotia-q1": "What is your top priority right now when you think about your goals for the future?",
            //Goals
            "scotia-goal-legacy": "Leave a legacy",
            "scotia-goal-home": "Purchase a second property",
            "scotia-goal-travel": "Enjoy leisure and travel",
            "scotia-goal-children": "Help children or grandchildren",
            "scotia-goal-expand-business": "Expand my business",
            "scotia-goal-lifestyle": "Maintain lifestyle",
            "scotia-goal-parents": "Help parents",
            "scotia-goal-start-business": "Start a business",
            "scotia-goal-succession": "Plan for business succession",
            "scotia-goal-nest": "Manage nest egg",
            //Q2
            "scotia-pre-q2": "",
            "scotia-q2": "Which potential future scenario would you prioritize planning for?",
            //Q2 choices
            "scotia-q2-choice-1": "No unexpected health issues",
            "scotia-q2-choice-2": "Unexpected health issue arises for me",
            "scotia-q2-choice-3": "Unexpected health issue for me or my partner",
            "scotia-q2-choice-4": "Unexpected health issue for both me and my partner",
            //Q3
            "scotia-q3": "In the absence of planning, how would you fund costs?",
            //Q3 choices
            "scotia-q3-choice-1": "Sell my house",
            "scotia-q3-choice-2": "Use my savings",
            "scotia-q3-choice-3": "I have insurance",
            "scotia-q3-choice-4": "I don’t know",
            //outro
            "scotia-q4": "Call To Action",
            "scotia-q4-choice-1": "Connect with us",
            "scotia-outro": "",
            "scotia-outro-image": ""
        };
        //string remapping fr
        var objectRemapsFr = {
            "scotia-intro-image": "",
            "scotia-intro": "",
            "scotia-q1": "Quelle est votre priorité aujourd’hui quand vous pensez à votre avenir?",
            //Goals
            "scotia-goal-legacy": "Laisser un héritage",
            "scotia-goal-home": "Acheter une propriété secondaire",
            "scotia-goal-travel": "M’adonner à des loisirs et voyager",
            "scotia-goal-children": "Aider mes enfants ou petits-enfants",
            "scotia-goal-expand-business": "Faire croître mon entreprise",
            "scotia-goal-lifestyle": "Maintenir mon mode de vie",
            "scotia-goal-parents": "Aider mes parents",
            "scotia-goal-start-business": "Démarrer une entreprise",
            "scotia-goal-succession": "Planifier la relève de mon entreprise",
            "scotia-goal-nest": "Gérer mon épargne",
            //Q2
            "scotia-pre-q2": "",
            "scotia-q2": "À quel scénario hypothétique voudriez-vous donner la priorité dans vos plans?",
            //Q2 choices
            "scotia-q2-choice-1": "Aucun problème de santé imprévu",
            "scotia-q2-choice-2": "J’ai un problème de santé imprévu",
            "scotia-q2-choice-3": "Mon partenaire ou moi avons un problème de santé imprévu",
            "scotia-q2-choice-4": "Mon partenaire et moi avons un problème de santé imprévu",
            //Q3
            "scotia-q3": "Détrompez-vous. Si vous ne faites aucun plan et que des problèmes de santé surviennent, comment paierez-vous les frais?",
            //Q3 choices
            "scotia-q3-choice-1": "Vendre ma maison",
            "scotia-q3-choice-2": "Utiliser mon épargne",
            "scotia-q3-choice-3": "J’ai une assurance",
            "scotia-q3-choice-4": "Je ne sais pas",
            //outro
            "scotia-q4": "appel à l'action",
            "scotia-q4-choice-1": "Nous joindre",
            "scotia-outro": "",
            "scotia-outro-image": ""
        };
        var goalObjs = {
            selectedGoals: [],
            selectedScenario: [],
            selectedFunding: []
        };
        var proceedStates = {
            proceedBtn1Active: false,
            proceedBtn2Active: false,
            proceedBtn3Active: false
        };
        var defaultAnimations = animations.slice(0, 5); //intro seq
        defaultAnimations.push.apply(//intro seq
        defaultAnimations, animations.slice(13, 16)); //q2 seq
        defaultAnimations.push.apply(//q2 seq
        defaultAnimations, animations.slice(19, 21)); //q3 seq
        defaultAnimations.push.apply(//q3 seq
        defaultAnimations, animations.slice(24, 25)); //outro seq
        var introArray = ["scotia-intro-image", "scotia-intro", "scotia-q1"];
        var q2Array = ["scotia-pre-q2", "scotia-q2"];
        var q3Array = ["scotia-q3"];
        var outroArray = ["scotia-outro", "scotia-outro-image"];
        var defaultGoal = ["scotia-goal-legacy", "scotia-goal-home"];
        var defaultScenario = ["scotia-q2-choice-1"];
        var defaultFunding = ["scotia-q3-choice-1"];
        this.player = new canvas_player_1.default(this.container, animations, {
            autoplay: false,
            domOverlay: true,
            backgroundMusic: {
                fadeOut: true,
                // Update soundClipID when the background music has been added to the first Animate file in the timeline.
                soundClipID: ""
            },
            dynamicTimeline: defaultAnimations.map(function (animation) { return animation.meta.TITLE; }),
            enableCC: true,
            // Update fonts for client.
            fonts: ["'Helvetica'"],
            pixelDensity: devicePixelRatio,
            rootName: "",
            nativeAudio: true,
            stageVars: __assign(__assign({}, this.stageVars), { goalObjs: goalObjs, proceedStates: proceedStates, pauseForInputs: function () {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                    //resetVideoSources();
                    onSelectionScreen = true;
                    if (!stoppedAtFrame) {
                        canvasPlayer.pause();
                        //setTimeout(() => {
                        stoppedAtFrame = canvasPlayer.exportRoot.currentFrame;
                        //}, 100);
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        _this.controls.resumePlay = false;
                        _this.controls.preventClickAction = true;
                        if (overlay)
                            overlay.style.pointerEvents = "";
                        if (typeof bgSound !== "undefined" && bgSound.paused) {
                            //bgSound.position = canvasPlayer.getCurrentTime() * 1000;
                            bgSound.paused = false;
                        }
                    }
                    if ((_a = _this.player) === null || _a === void 0 ? void 0 : _a.paused) {
                        playerControls.getElementsByClassName("cp-controls-container")[0].classList.add("hidden");
                    }
                    //reset order of videos, then swap scenes if current video element is not playing next video in sequence
                    //fixes cases where user returns to previous chapter and does not interact with menu video selections
                    resetVideoSources();
                    if (_this.currentScene.sceneName == "scotia-q1" &&
                        !((_b = _this.videoElem) === null || _b === void 0 ? void 0 : _b.src.includes(goalObjs.selectedGoals[0])) &&
                        ((_c = _this.nextScene) === null || _c === void 0 ? void 0 : _c.sceneName) == goalObjs.selectedGoals[0]) {
                        swapVideoSources();
                    }
                    if (_this.currentScene.sceneName == "scotia-q2" &&
                        !((_d = _this.videoElem) === null || _d === void 0 ? void 0 : _d.src.includes(goalObjs.selectedScenario[0])) &&
                        ((_e = _this.nextScene) === null || _e === void 0 ? void 0 : _e.sceneName) == goalObjs.selectedScenario[0]) {
                        swapVideoSources();
                    }
                    if (_this.currentScene.sceneName == "scotia-q3" &&
                        !((_f = _this.videoElem) === null || _f === void 0 ? void 0 : _f.src.includes(goalObjs.selectedFunding[0])) &&
                        ((_g = _this.nextScene) === null || _g === void 0 ? void 0 : _g.sceneName) == goalObjs.selectedFunding[0]) {
                        swapVideoSources();
                    }
                    (_h = _this.videoElem) === null || _h === void 0 ? void 0 : _h.pause();
                    (_j = _this.videoElemAlt) === null || _j === void 0 ? void 0 : _j.pause();
                }, continueVideo: function (_targetP, _targetB) {
                    currentFrame = canvasPlayer.exportRoot.currentFrame;
                    //validation check
                    if (_targetB.name == "q1_proceed") {
                        if (goalObjs.selectedGoals.length > 0) {
                            //*Nest egg and lifestyle option are the same video
                            //only play one of them
                            if (goalObjs.selectedGoals.includes("scotia-goal-nest") &&
                                goalObjs.selectedGoals.includes("scotia-goal-lifestyle")) {
                                goalObjs.selectedGoals = goalObjs.selectedGoals.filter(function (scene) {
                                    return scene != "scotia-goal-nest";
                                });
                            }
                            updatedTimeline = introArray.concat(goalObjs.selectedGoals, q2Array);
                            //if selected scenario was already chosen, use that for new timeline, else use default
                            if (goalObjs.selectedScenario.length > 0) {
                                updatedTimeline = updatedTimeline.concat(goalObjs.selectedScenario, q3Array);
                            }
                            else {
                                updatedTimeline = updatedTimeline.concat(defaultScenario, q3Array);
                            }
                            //if selected funding was already chosen, use that for new timeline, else use default
                            if (goalObjs.selectedFunding.length > 0) {
                                updatedTimeline = updatedTimeline.concat(goalObjs.selectedFunding, outroArray);
                            }
                            else {
                                updatedTimeline = updatedTimeline.concat(defaultFunding, outroArray);
                            }
                            _this.updateAnimationTimeline(updatedTimeline, goalObjs.selectedGoals[0]);
                            setupChapters();
                            unlockChapter(0);
                            playerControls
                                .getElementsByClassName("cp-controls-container")[0]
                                .classList.remove("hidden");
                            onSelectionScreen = false;
                            //let continueBtn = document.querySelector(".proceed_btn") as HTMLButtonElement;
                            //continueBtn.disabled = false;
                            //goalObjs.selectedGoals = [];
                        }
                    }
                    else if (_targetB.name == "q2_proceed") {
                        if (goalObjs.selectedScenario.length > 0) {
                            //if selected goals were already chosen, use that for new timeline, else use default
                            if (goalObjs.selectedGoals.length > 0) {
                                updatedTimeline = introArray.concat(goalObjs.selectedGoals, q2Array);
                            }
                            else {
                                updatedTimeline = introArray.concat(defaultGoal, q2Array);
                            }
                            //if selected scenario was already chosen, use that for new timeline, else use default
                            if (goalObjs.selectedScenario.length > 0) {
                                updatedTimeline = updatedTimeline.concat(goalObjs.selectedScenario, q3Array);
                            }
                            else {
                                updatedTimeline = updatedTimeline.concat(defaultScenario, q3Array);
                            }
                            //if selected funding was already chosen, use that for new timeline, else use default
                            if (goalObjs.selectedFunding.length > 0) {
                                updatedTimeline = updatedTimeline.concat(goalObjs.selectedFunding, outroArray);
                            }
                            else {
                                updatedTimeline = updatedTimeline.concat(defaultFunding, outroArray);
                            }
                            _this.updateAnimationTimeline(updatedTimeline, goalObjs.selectedScenario[0]);
                            setupChapters();
                            unlockChapter(1);
                            playerControls
                                .getElementsByClassName("cp-controls-container")[0]
                                .classList.remove("hidden");
                            onSelectionScreen = false;
                            //let continueBtn = document.querySelector(".proceed_btn") as HTMLButtonElement;
                            //continueBtn.disabled = false;
                        }
                    }
                    else if (_targetB.name == "q3_proceed") {
                        if (goalObjs.selectedFunding.length > 0) {
                            //if selected goals were already chosen, use that for new timeline, else use default
                            if (goalObjs.selectedGoals.length > 0) {
                                updatedTimeline = introArray.concat(goalObjs.selectedGoals, q2Array);
                            }
                            else {
                                updatedTimeline = introArray.concat(defaultGoal, q2Array);
                            }
                            //if selected scenario was already chosen, use that for new timeline, else use default
                            if (goalObjs.selectedScenario.length > 0) {
                                updatedTimeline = updatedTimeline.concat(goalObjs.selectedScenario, q3Array);
                            }
                            else {
                                updatedTimeline = updatedTimeline.concat(defaultScenario, q3Array);
                            }
                            //if selected funding was already chosen, use that for new timeline, else use default
                            if (goalObjs.selectedFunding.length > 0) {
                                updatedTimeline = updatedTimeline.concat(goalObjs.selectedFunding, outroArray);
                            }
                            else {
                                updatedTimeline = updatedTimeline.concat(defaultFunding, outroArray);
                            }
                            _this.updateAnimationTimeline(updatedTimeline, goalObjs.selectedFunding[0]);
                            setupChapters();
                            unlockChapter(2);
                            playerControls
                                .getElementsByClassName("cp-controls-container")[0]
                                .classList.remove("hidden");
                            onSelectionScreen = false;
                            //let continueBtn = document.querySelector(".proceed_btn") as HTMLButtonElement;
                            //continueBtn.disabled = false;
                        }
                    }
                    isPreloading = false;
                }, sendDataResponse: function (_targetP, _targetB) {
                    //creates a response object containing user selections
                    var responseObj = {
                        "": ""
                    };
                    var htmlObj = "<p>";
                    htmlObj += stringRemapper("scotia-q1") + "<br>";
                    goalObjs.selectedGoals.forEach(function (element) {
                        htmlObj += stringRemapper(element) + "<br>";
                    });
                    htmlObj += "<br>" + stringRemapper("scotia-q2") + "<br>";
                    htmlObj += stringRemapper(goalObjs.selectedScenario[0]) + "<br>";
                    htmlObj += "<br>" + stringRemapper("scotia-q3") + "<br>";
                    htmlObj += stringRemapper(goalObjs.selectedFunding[0]) + "</p>";
                    htmlObj += "<br>" + stringRemapper("scotia-q4") + "<br>";
                    htmlObj += stringRemapper("scotia-q4-choice-1") + "</p>";
                    responseObj[""] = htmlObj;
                    var responseObjJson = JSON.stringify(responseObj);
                    // sessionStorage.setItem("totalWealthToolQnA", JSON.stringify(responseObj));
                    //open testing or production url based on language
                    if (DEBUG) {
                        console.log(responseObjJson, "-----result");
                        if (language == "en") {
                            window.parent.postMessage(responseObjJson, "https://" + testingUrlEn.split("/")[2]);
                            window.open(testingUrlEn);
                        }
                        else {
                            window.parent.postMessage(responseObjJson, "https://" + testingUrlFr.split("/")[2]);
                            window.open(testingUrlFr);
                        }
                    }
                    else {
                        if (language == "en") {
                            window.parent.postMessage(responseObjJson, "https://" + productionUrlEn.split("/")[2]);
                            window.open(productionUrlEn);
                        }
                        else {
                            window.parent.postMessage(responseObjJson, "https://" + productionUrlFr.split("/")[2]);
                            window.open(productionUrlFr);
                        }
                    }
                }, resetStageVars: function (_targetP, _targetB) {
                    //resets videodata
                    //hide controls for scrubbing and show large replay button instead
                    goalObjs.selectedGoals = [];
                    goalObjs.selectedScenario = [];
                    goalObjs.selectedFunding = [];
                    $(".cp-large-replay").trigger("click");
                    proceedStates.proceedBtn1Active = false;
                    proceedStates.proceedBtn2Active = false;
                    proceedStates.proceedBtn3Active = false;
                    console.log("Replaying");
                    chapterData = [];
                    setupChapters();
                    //reset bgsound
                    replaying = false;
                    bgSound.position = 0;
                    bgSound.volume = 1;
                    bgSound.paused = false;
                    _this.largePlayButton.classList.add("hide");
                    _this.playButton.classList.add("hide");
                    playerControls.getElementsByClassName("cp-controls-container")[0].classList.remove("hidden");
                    //reset framelimit to first locked frame
                    _this.controls.frameLimit = chapterData[0].chapterFrame;
                    //ensure playbutton overlay is hidden on replay, allow background clicks
                    setTimeout(function () {
                        _this.playButton.classList.add("hide");
                        _this.largePlayButton.classList.add("hide");
                        _this.container.style.pointerEvents = "auto";
                    }, 500);
                }, fadeOutBGMusic: function () {
                    //prevent controls interaction once music fades out, prevent background click
                    playerControls.getElementsByClassName("cp-controls-container")[0].classList.add("hidden");
                    _this.container.style.pointerEvents = "none";
                    var vol = bgSound.volume;
                    var interval = 100; // 100ms interval
                    var fadeout = setInterval(function () {
                        // Reduce volume by 0.05 as long as it is above 0
                        // This works as long as you start with a multiple of 0.05!
                        if (bgSound.volume > 0) {
                            bgSound.paused = false;
                            vol -= 0.1;
                            bgSound.volume = vol;
                        }
                        else {
                            // Stop the setInterval when 0 is reached
                            clearInterval(fadeout);
                        }
                    }, interval);
                }, getVideoToPlay: function (sceneName) {
                    playerControls.getElementsByClassName("cp-controls-container")[0].classList.remove("hidden");
                    var videoFound = false;
                    isScrubbing = false;
                    for (var i = 0; i < Object.keys(videoObjs).length; i++) {
                        var value = Object.values(videoObjs)[i];
                        if (value.includes(sceneName)) {
                            videoFound = true;
                            return value;
                        }
                    }
                    if (!videoFound) {
                        console.log("no video path for *".concat(sceneName, "*, check animate video name matches video name in videos folder"));
                    }
                }, updateGoals: function (_targetP, checkbox) {
                    //this.updateCurrentScene("scotia-q1");
                    if (checkbox.checked && goalObjs.selectedGoals.length < 3) {
                        goalObjs.selectedGoals.push(checkbox.id);
                    }
                    else {
                        goalObjs.selectedGoals = goalObjs.selectedGoals.filter(function (e) {
                            checkbox.checked = false;
                            return e !== checkbox.id;
                        });
                    }
                    var container = document.querySelector(".cp-overlay");
                    var proceed_btn;
                    //proceed button is on separate shadow dom compared to input elements
                    //in order to update it's styling based on input changes need to
                    //ensure accessing correct shadow node
                    if (container.childNodes[0].shadowRoot.children[1].id === "proceed_btn") {
                        proceed_btn = container.childNodes[0].shadowRoot.children[1];
                    }
                    if (container.childNodes[1].shadowRoot.children[1].id === "proceed_btn") {
                        proceed_btn = container.childNodes[1].shadowRoot.children[1];
                    }
                    if (goalObjs.selectedGoals[0]) {
                        preloadVideo(goalObjs.selectedGoals[0]);
                        proceedStates.proceedBtn1Active = true;
                        proceed_btn.style.pointerEvents = "auto";
                        proceed_btn.style.opacity = "100%";
                        proceed_btn.setAttribute("aria-label", language == "en" ? "Proceed" : "Poursuivre");
                    }
                    else {
                        proceedStates.proceedBtn1Active = false;
                        proceed_btn.style.pointerEvents = "none";
                        proceed_btn.style.opacity = "25%";
                        proceed_btn.setAttribute("aria-label", language == "en"
                            ? "Proceed button unavailable please make a selection"
                            : "Il est impossible de cliquer sur le bouton Poursuivre, veuillez choisir une option.");
                    }
                }, updateScenario: function (checkboxes, checkbox) {
                    //this.updateCurrentScene("scotia-q2");
                    //resetVideoSources();
                    if (checkbox.checked) {
                        goalObjs.selectedScenario.pop();
                        goalObjs.selectedScenario.push(checkbox.id);
                        for (var i = 0; i < checkboxes.length; i++) {
                            checkboxes[i].checked = false;
                        }
                        checkbox.checked = true;
                    }
                    else {
                        goalObjs.selectedScenario.pop();
                    }
                    var container = document.querySelector(".cp-overlay");
                    var proceed_btn;
                    if (container.childNodes[0].shadowRoot.children[1].id === "proceed_btn") {
                        proceed_btn = container.childNodes[0].shadowRoot.children[1];
                    }
                    if (container.childNodes[1].shadowRoot.children[1].id === "proceed_btn") {
                        proceed_btn = container.childNodes[1].shadowRoot.children[1];
                    }
                    if (goalObjs.selectedScenario[0]) {
                        preloadVideo(checkbox.id);
                        proceedStates.proceedBtn2Active = true;
                        proceed_btn.style.pointerEvents = "auto";
                        proceed_btn.style.opacity = "100%";
                        proceed_btn.setAttribute("aria-label", language == "en" ? "Proceed" : "Poursuivre");
                    }
                    else {
                        proceedStates.proceedBtn2Active = false;
                        proceed_btn.style.pointerEvents = "none";
                        proceed_btn.style.opacity = "25%";
                        proceed_btn.setAttribute("aria-label", language == "en"
                            ? "Proceed button unavailable please make a selection"
                            : "Il est impossible de cliquer sur le bouton Poursuivre, veuillez choisir une option.");
                    }
                }, updateFunding: function (checkboxes, checkbox) {
                    //this.updateCurrentScene("scotia-q3");
                    //resetVideoSources();
                    if (checkbox.checked) {
                        goalObjs.selectedFunding.pop();
                        goalObjs.selectedFunding.push(checkbox.id);
                        for (var i = 0; i < checkboxes.length; i++) {
                            checkboxes[i].checked = false;
                        }
                        checkbox.checked = true;
                    }
                    else {
                        goalObjs.selectedFunding.pop();
                    }
                    var container = document.querySelector(".cp-overlay");
                    var proceed_btn;
                    if (container.childNodes[0].shadowRoot.children[1].id === "proceed_btn") {
                        proceed_btn = container.childNodes[0].shadowRoot.children[1];
                    }
                    if (container.childNodes[1].shadowRoot.children[1].id === "proceed_btn") {
                        proceed_btn = container.childNodes[1].shadowRoot.children[1];
                    }
                    if (goalObjs.selectedFunding[0]) {
                        preloadVideo(checkbox.id);
                        proceedStates.proceedBtn3Active = true;
                        proceed_btn.style.pointerEvents = "auto";
                        proceed_btn.style.opacity = "100%";
                        proceed_btn.setAttribute("aria-label", language == "en" ? "Proceed" : "Poursuivre");
                    }
                    else {
                        proceedStates.proceedBtn3Active = false;
                        proceed_btn.style.pointerEvents = "none";
                        proceed_btn.style.opacity = "25%";
                        proceed_btn.setAttribute("aria-label", language == "en"
                            ? "Proceed button unavailable please make a selection"
                            : "Il est impossible de cliquer sur le bouton Poursuivre, veuillez choisir une option.");
                    }
                } })
        });
        var canvasPlayer = this.player;
        var lastEvent = "keyboard";
        //play controls used to trigger video elements at start
        //direct user interactivity required to begin videos
        var setupButtonListener = function (playButton) {
            playButton.addEventListener("click", function (e) {
                var _a, _b;
                playButton.classList.add("hide");
                if (_this.videoElem.readyState == 4) {
                    _this.videoElem.play();
                }
                if (_this.initialLoad) {
                    //allow background click-to-play after initial load
                    _this.container.style.pointerEvents = "auto";
                    _this.initialLoad = false;
                    (_a = _this.videoElemAlt) === null || _a === void 0 ? void 0 : _a.play();
                    (_b = _this.videoElemAlt) === null || _b === void 0 ? void 0 : _b.pause();
                    pausedForLoading = true;
                }
            });
        };
        //adds seekbar listener, used to determine whether videos should pause or show preloader
        var setupScrubbingListener = function () {
            var _a;
            (_a = document.querySelector(".cp-seekbar")) === null || _a === void 0 ? void 0 : _a.addEventListener("change", function (e) {
                var _a, _b, _c;
                isScrubbing = true;
                (_a = _this.videoElem) === null || _a === void 0 ? void 0 : _a.pause();
                (_b = _this.videoElemAlt) === null || _b === void 0 ? void 0 : _b.pause();
                (_c = _this.player) === null || _c === void 0 ? void 0 : _c.pause();
                resetVideoSources();
                setTimeout(function () {
                    isScrubbing = false;
                    //this.preloader?.classList.add("hide");
                }, 1000);
            });
        };
        //function that grabs the current frame and runs through all the available scenes start/end times
        //to determine what the current scene name is
        var getCurrentScene = function () {
            var _a;
            _this.gettingSceneInfo = true;
            _this.animationCurrentTime =
                (_this.player.exportRoot.currentFrame * 1000) / _this.player.animationProperties.fps / 1000;
            //loop through all scenes in timeline and find which scene corresponds to currentframe
            for (var i = 0; i < timelineSceneData.size; i++) {
                var sceneCounter = (_a = timelineSceneData.get(i)) === null || _a === void 0 ? void 0 : _a.startTime;
                if (sceneCounter <= _this.animationCurrentTime) {
                    _this.currentScene = timelineSceneData.get(i);
                    _this.nextScene = timelineSceneData.get(i + 1);
                }
            }
            _this.gettingSceneInfo = false;
        };
        //return the video elems to their default state classnames
        var resetVideoSources = function () {
            _this.videoElem.classList.add("cp-video");
            _this.videoElem.classList.remove("cp-video-preload");
            _this.videoElemAlt.classList.add("cp-video-preload");
            _this.videoElemAlt.classList.remove("cp-video");
        };
        //animate files augmented with dynamic mp4 capabilities pull frames from the video elem with a "cp-video" classname
        //this function switches which video tag has that classname to allow for continous video frame rendering
        //used when one video ends and the next is setup for preloading
        var swapVideoSources = function () {
            var _a;
            if ((_a = _this.videoElem) === null || _a === void 0 ? void 0 : _a.classList.contains("cp-video")) {
                _this.videoElem.classList.remove("cp-video");
                _this.videoElem.classList.add("cp-video-preload");
                _this.videoElemAlt.classList.remove("cp-video-preload");
                _this.videoElemAlt.classList.add("cp-video");
            }
            else {
                _this.videoElem.classList.add("cp-video");
                _this.videoElem.classList.remove("cp-video-preload");
                _this.videoElemAlt.classList.add("cp-video-preload");
                _this.videoElemAlt.classList.remove("cp-video");
            }
        };
        var showHideFocus = function (e) {
            if (e.type === "keydown" || e.type === "keyup") {
                lastEvent = "keyboard";
            }
            else {
                lastEvent = "mouse";
            }
        };
        playerControls.addEventListener("keydown", showHideFocus, true);
        playerControls.addEventListener("keyup", showHideFocus, true);
        playerControls.addEventListener("mousedown", showHideFocus, true);
        playerControls.addEventListener("mouseup", showHideFocus, true);
        playerControls.addEventListener("focusin", function () {
            if (lastEvent === "keyboard") {
                playerControls.classList.remove("hide-focus");
            }
            else {
                playerControls.classList.add("hide-focus");
            }
        }, true);
        //update chapter activated property, update chapter styling
        var unlockChapter = function (index) {
            if (!chapterData[index].activated) {
                chapterData[index].activated = true;
                if (chapterData[index + 1]) {
                    nextLockedFrame = chapterData[index + 1].chapterFrame;
                    _this.controls.clearFrameLimit();
                    _this.controls.frameLimit = nextLockedFrame;
                }
                else {
                    _this.controls.clearFrameLimit();
                }
            }
            chapterData.forEach(function (chapter, index) {
                var _a;
                if (chapter.activated) {
                    (_a = document.querySelector("#chapter-" + index)) === null || _a === void 0 ? void 0 : _a.classList.add("cp-chapter-unlocked");
                }
            });
        };
        //update chapter breakpoints
        var setupChapterFrames = function () {
            currentFrame = canvasPlayer.exportRoot.currentFrame;
            stopFrames = []; //array of stopframes from current position onwards
            var ariaWord = language == "en" ? "Chapter" : "Chapitre";
            if (canvasPlayer.exportRoot.dynamicLabels) {
                canvasPlayer.exportRoot.dynamicLabels.forEach(function (l, index) {
                    if (l.label.startsWith("stopFrame")) {
                        if (!chapterData[index]) {
                            var chapterObj_1 = {
                                chapterFrame: 0,
                                activated: false,
                                ariaLabel: ariaWord
                            };
                            chapterData.push(chapterObj_1);
                        }
                        chapterData[index].chapterFrame = l.position;
                        chapterData[index].ariaLabel = ariaWord + " " + (index + 1);
                    }
                });
            }
            if (!nextLockedFrame) {
                nextLockedFrame = chapterData[0].chapterFrame;
                _this.controls.clearFrameLimit();
                _this.controls.frameLimit = nextLockedFrame;
            }
        };
        //With RM library integration
        //adds chapter elements on timeline based on stopframes of animation
        /*
        const setupChapters = (): void => {
            //get new stop frame locations
            setupChapterFrames();

            //remove and add new markers
            this.controls!.addChapters(chapterData);

            document.querySelectorAll(".cp-timeline-chapter").forEach((chapterBtn, index) => {
                chapterBtn.addEventListener("mousedown", (e) => {
                    e.stopPropagation();
                    console.log("INDEX CLICKED", index);
                    if (chapterData[index].activated) {
                        this.player?.goToFrame(chapterData[index].chapterFrame);
                        this.player?.pause();
                        if (typeof bgSound !== "undefined" && bgSound.paused) {
                            //bgSound.position = canvasPlayer.getCurrentTime() * 1000;
                            bgSound.paused = false;
                        }
                        playerControls.getElementsByClassName("cp-controls-container")[0].classList.add("hidden");
                    }
                });
            });
        };
        */
        //adds chapter elements on timeline based on stopframes of animation
        var setupChapters = function () {
            // //remove any old chapters
            removeChapters();
            //get new stop frame locations
            setupChapterFrames();
            var seekbar = playerControls.querySelector(".cp-seekbar");
            var animationDuration = _this.player.exportRoot.duration;
            var chapters = [];
            //for each stop frame, calculate what percentage in the video it occurs at
            chapterData.forEach(function (chapter) {
                chapters.push(chapter.chapterFrame / animationDuration);
            });
            // //chapter container gets overlayed ontop of seekbar
            var chapterContainer = document.createElement("div");
            chapterContainer.classList.add("cp-chapter-container");
            chapters.forEach(function (chapter, index) {
                var chapterBtn = document.createElement("button");
                chapterBtn.id = "chapter-" + index;
                chapterBtn.style.left = chapter * 100 + "%"; //move chapter to correct percentage amount, subtract a bit to account for chapter width
                chapterBtn.style.transform = "translate(-50%)";
                chapterBtn.classList.add("cp-timeline-chapter");
                chapterBtn.setAttribute("aria-label", chapterData[index].ariaLabel);
                chapterBtn.addEventListener("mousedown", function (e) {
                    var _a, _b;
                    e.stopPropagation();
                    if (chapterData[index].activated) {
                        (_a = _this.player) === null || _a === void 0 ? void 0 : _a.goToFrame(chapterData[index].chapterFrame);
                        (_b = _this.player) === null || _b === void 0 ? void 0 : _b.pause();
                        if (typeof bgSound !== "undefined" && bgSound.paused) {
                            //bgSound.position = canvasPlayer.getCurrentTime() * 1000;
                            bgSound.paused = false;
                        }
                        playerControls.getElementsByClassName("cp-controls-container")[0].classList.add("hidden");
                        onSelectionScreen = true;
                        switch (index) {
                            case 0:
                                preloadVideo(goalObjs.selectedGoals[0]);
                                break;
                            case 1:
                                preloadVideo(goalObjs.selectedScenario[0]);
                                break;
                            case 2:
                                preloadVideo(goalObjs.selectedFunding[0]);
                                break;
                        }
                    }
                });
                chapterContainer.appendChild(chapterBtn);
            });
            seekbar === null || seekbar === void 0 ? void 0 : seekbar.appendChild(chapterContainer);
            chapterData.forEach(function (chapter, index) {
                var _a;
                if (chapter.activated) {
                    (_a = document.querySelector("#chapter-" + index)) === null || _a === void 0 ? void 0 : _a.classList.add("cp-chapter-unlocked");
                }
            });
        };
        //removes chapter elements on timeline
        var removeChapters = function () {
            var _a;
            (_a = document.querySelector(".cp-chapter-container")) === null || _a === void 0 ? void 0 : _a.remove();
        };
        //gets array of all scenes and determine various start/end times and whether scene is a video or not
        var setupVideoScenes = function () {
            var totalTime = 0;
            //determine time ranges for each section in dynamic timeline
            //determine whether each section has a video
            for (var i = 0; i < _this.player.exportRoot.dynamicScenes.length; i++) {
                var frames = _this.player.exportRoot.dynamicScenes[i].duration;
                var fps = _this.player.animationProperties.fps;
                var duration = frames / fps;
                var sceneName = _this.player.exportRoot.dynamicScenes[i].id;
                var isVideo = false;
                for (var i_1 = 0; i_1 < Object.keys(videoObjs).length; i_1++) {
                    var value = Object.values(videoObjs)[i_1];
                    if (value.includes(sceneName + ".mp4")) {
                        isVideo = true;
                    }
                }
                totalTime += duration;
                timelineSceneData.set(i, {
                    sceneName: sceneName,
                    isVideo: isVideo,
                    duration: duration,
                    startTime: totalTime - duration,
                    endTime: totalTime
                });
            }
        };
        //focus listner to stop BG Music when the tab goes out of focus
        var addFocusListener = function (listener) {
            var visibilityChange = "";
            if (typeof document.hidden !== "undefined") {
                // Opera 12.10 and Firefox 18 and later support
                hidden = "hidden";
                visibilityChange = "visibilitychange";
            }
            else if (typeof document.msHidden !== "undefined") {
                hidden = "msHidden";
                visibilityChange = "msvisibilitychange";
            }
            else if (typeof document.webkitHidden !== "undefined") {
                hidden = "webkitHidden";
                visibilityChange = "webkitvisibilitychange";
            }
            if (typeof document.addEventListener === "undefined" || typeof document.hidden === "undefined") {
                console.warn("focus/blur changes on tab require Google Chrome or Firefox");
            }
            else {
                document.addEventListener(visibilityChange, listener, false);
            }
        };
        //adds listeners to various elements on initial load
        var initialLoadSetup = function () {
            setupButtonListener(_this.playButton);
            setupButtonListener(_this.largePlayButton);
            setupScrubbingListener();
            var playButton = document.querySelector(".cp-play");
            setInterval(function () {
                //get active video element
                var activeElem = document.querySelector(".cp-video");
                //if video in ready state, play and hide preloader
                //else pause video and show preloader
                if (activeElem.readyState == 3 || activeElem.readyState == 4) {
                    playerControls.querySelector(".cp-preloader").classList.add("hide");
                    if (!isPreloading && pausedForLoading) {
                        activeElem.play();
                        canvasPlayer.play();
                        pausedForLoading = false;
                        playButton.style.pointerEvents = "auto";
                        if (bgSound) {
                            bgSound.paused = false;
                        }
                    }
                    if (isScrubbing) {
                        activeElem.pause();
                    }
                }
                else {
                    if (!isPreloading) {
                        playerControls.querySelector(".cp-preloader").classList.remove("hide");
                        canvasPlayer.pause();
                        pausedForLoading = true;
                        activeElem.pause();
                        playButton.style.pointerEvents = "none";
                        if (bgSound) {
                            bgSound.paused = false;
                        }
                    }
                    else {
                        playerControls.querySelector(".cp-preloader").classList.add("hide");
                    }
                }
            }, 500);
            playerControls.getElementsByClassName("cp-controls-container")[0].classList.add("hidden");
        };
        this.player.on("canplay", function () {
            var canvas = document.getElementsByTagName("canvas")[0];
            canvas.style.backgroundColor = "#000";
            _this.updateTranscript();
            _this.ready = true;
            if (_this.embedMode) {
                parent.postMessage({ type: "video_ready" }, location.origin);
            }
            if (_this.initialLoad) {
                initialLoadSetup();
            }
            setupChapters();
            setupVideoScenes();
        });
        Promise.all([this.loadBgMusic("../common/videos/" + language + "/background.mp3")]).then(function (_a) {
            var bgSoundInstance = _a[0];
            bgSound = bgSoundInstance;
            var wasBgSound = false;
            var wasVideoPlaying = false;
            var videoLoading = false;
            _this.player.on("timeupdate", function () {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                currentFrame = canvasPlayer.exportRoot.currentFrame;
                if (stoppedAtFrame && stoppedAtFrame !== currentFrame) {
                    stoppedAtFrame = false;
                    if (canvasPlayer.paused && !onSelectionScreen) {
                        canvasPlayer.play();
                    }
                }
                if (!_this.gettingSceneInfo) {
                    getCurrentScene();
                }
                //checks and sets video source on main active video element
                if (!((_a = _this.currentScene) === null || _a === void 0 ? void 0 : _a.isVideo)) {
                    _this.videoElem.pause();
                    _this.videoElemAlt.pause();
                }
                //checks and sets video source on secondary video element
                if (((_b = _this.nextScene) === null || _b === void 0 ? void 0 : _b.isVideo) && !videosSwapped) {
                    var isVideoSrcSyncyed = void 0;
                    if ((_c = _this.videoElem) === null || _c === void 0 ? void 0 : _c.classList.contains("cp-video")) {
                        isVideoSrcSyncyed = _this.videoElemAlt.src.includes(_this.nextScene.sceneName);
                    }
                    else {
                        isVideoSrcSyncyed = _this.videoElem.src.includes(_this.nextScene.sceneName);
                    }
                    if (!isVideoSrcSyncyed) {
                        var videoPath = void 0;
                        for (var i = 0; i < Object.keys(videoObjs).length; i++) {
                            var temp = Object.values(videoObjs)[i];
                            if (temp.includes(_this.nextScene.sceneName)) {
                                videoPath = temp;
                            }
                        }
                        if ((_d = _this.videoElem) === null || _d === void 0 ? void 0 : _d.classList.contains("cp-video")) {
                            if (_this.videoElemAlt.src != videoPath) {
                                _this.videoElemAlt.src = videoPath;
                                _this.videoElemAlt.pause();
                            }
                        }
                        else {
                            if (_this.videoElem.src != videoPath) {
                                _this.videoElem.src = videoPath;
                                _this.videoElem.pause();
                            }
                        }
                    }
                }
                //sets conditions for video swap
                //scene change happens when current scene gets to its end time - 1 frame
                var oneFrameLength = 1 / _this.player.animationProperties.fps;
                var condition1 = Number(parseFloat(_this.animationCurrentTime.toFixed(4))) >=
                    Number(parseFloat((((_e = _this.currentScene) === null || _e === void 0 ? void 0 : _e.endTime) - oneFrameLength).toFixed(4)));
                var condition2 = (_f = _this.nextScene) === null || _f === void 0 ? void 0 : _f.isVideo;
                var condition3 = !videosSwapped;
                if (condition1 && condition2 && condition3) {
                    if ((_g = _this.currentScene) === null || _g === void 0 ? void 0 : _g.isVideo) {
                        swapVideoSources();
                        document.querySelector(".cp-video").play();
                        document.querySelector(".cp-video-preload").pause();
                        (_h = _this.player) === null || _h === void 0 ? void 0 : _h.play();
                        videosSwapped = true;
                        setTimeout(function () {
                            videosSwapped = false;
                        }, 1000);
                    }
                }
            });
            _this.player.on("play", function () {
                _this.largePlayButton.classList.add("hide");
                if (bgSound.paused) {
                    bgSound.paused = false;
                }
                if (!overlay) {
                    overlay = container.querySelector(".cp-overlay");
                }
                if (stoppedAtFrame && !onSelectionScreen) {
                    stoppedAtFrame = false;
                }
                //ensure controls container is visible on play
                if (!playerControls.getElementsByClassName("cp-controls-container")[0].classList.contains("hidden")) {
                    playerControls.getElementsByClassName("cp-controls-container")[0].classList.remove("hidden");
                }
                overlay.style.pointerEvents = "none";
            });
            _this.player.on("pause", function () {
                if (!bgSound.paused && !pausedForLoading && !replaying) {
                    bgSound.paused = true;
                }
            });
            _this.player.on("fullscreenchange", function () {
                setTimeout(function () {
                    setupChapters();
                }, 100);
            });
            addFocusListener(function () {
                var _a, _b;
                if (document.hidden) {
                    if (!bgSound.paused) {
                        wasBgSound = true;
                        bgSound.paused = true;
                    }
                    if ((_a = _this.currentScene) === null || _a === void 0 ? void 0 : _a.isVideo) {
                        wasVideoPlaying = !_this.videoElem.paused;
                        _this.videoElem.pause();
                    }
                }
                else {
                    if (wasBgSound) {
                        bgSound.paused = false;
                        wasBgSound = false;
                    }
                    if (wasVideoPlaying) {
                        _this.videoElem.play();
                        (_b = _this.player) === null || _b === void 0 ? void 0 : _b.play();
                        wasVideoPlaying = false;
                    }
                }
            });
        });
        if (this.controls) {
            this.controls.formatTranscript = this.formatTranscript();
        }
        (_a = this.controls) === null || _a === void 0 ? void 0 : _a.toggleIndicators(true);
        (_b = this.controls) === null || _b === void 0 ? void 0 : _b.attachCanvasPlayer(this.player);
    };
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    RMDynamicVideo.prototype.updateTranscript = function () {
        var _a, _b, _c;
        var descriptions = ((_a = this.player) === null || _a === void 0 ? void 0 : _a.generateTranscript()) || [];
        var sanitizedDescriptions = (0, utilities_1.sanitizeDescriptions)(descriptions, (_b = this.controls) === null || _b === void 0 ? void 0 : _b.formatTranscript);
        var htmlURL = "".concat(i18n("transcript"), ".html");
        (_c = this.controls) === null || _c === void 0 ? void 0 : _c.updateTranscript((0, utilities_1.buildTranscriptHTML)(sanitizedDescriptions), "#transcript-body", htmlURL);
    };
    return RMDynamicVideo;
}(custom_elements_1.HTMLCustomElement));
(0, custom_elements_1.registerElement)("rm-dynamic-video", RMDynamicVideo);
exports.default = RMDynamicVideo;
//# sourceMappingURL=module.js.map